import { create } from "zustand";

interface Props {
  gradeLevels: any[];
  setGradeLevels: (value: any[]) => void;
  subjects: any[];
  setSubjects: (value: any[]) => void;
  curriculums: any[];
  setCurriculums: (value: any[]) => void;
  courseStatus: any[];
  setCourseStatus: (value: any[]) => void;
  schoolYears: any[];
  setSchoolYears: (value: any[]) => void;
  organizations: any[];
  setOrganizations: (value: any[]) => void;
  accreditations: any[];
  setAccreditations: (value: any[]) => void;
  programs: any[];
  setPrograms: (value: any[]) => void;
  gradeApprovalStatus: any[];
  setGradeApprovalStatus: (value: any[]) => void;
  students: any[];
  setStudents: (value: any[]) => void;
  skills: any[];
  setSkills: (value: any[]) => void;
  subSkills: any[];
  setSubSkills: (value: any[]) => void;
  teachers: any[];
  setTeachers: (value: any[]) => void;
  parentTeachers: any[];
  setParentTeachers: (value: any[]) => void;
  gradingComponents: any[];
  setGradingComponents: (value: any[]) => void;
  objectiveType: any[];
  setObjectiveType: (value: any[]) => void;
  catalogs: any[];
  setCatalogs: (value: any[]) => void;
  classes: any[];
  setClasses: (value: any[]) => void;
}

// onLoad teach Data
const useLookupStore = create<Props>((set) => ({
  gradeLevels: [],
  setGradeLevels: (gradeLevels) => set({ gradeLevels }),
  subjects: [],
  setSubjects: (subjects) => set({ subjects }),
  curriculums: [],
  setCurriculums: (curriculums) => set({ curriculums }),
  courseStatus: [],
  setCourseStatus: (courseStatus) => set({ courseStatus }),
  schoolYears: [],
  setSchoolYears: (schoolYears) => set({ schoolYears }),
  organizations: [],
  setOrganizations: (organizations) => set({ organizations }),
  accreditations: [],
  setAccreditations: (accreditations) => set({ accreditations }),
  programs: [],
  setPrograms: (programs) => set({ programs }),
  gradeApprovalStatus: [],
  setGradeApprovalStatus: (gradeApprovalStatus) => set({ gradeApprovalStatus }),
  students: [],
  setStudents: (students) => set({ students }),
  skills: [],
  setSkills: (skills) => set({ skills }),
  subSkills: [],
  setSubSkills: (skills) => set({ skills }),
  teachers: [],
  setTeachers: (teachers) => set({ teachers }),
  parentTeachers: [],
  setParentTeachers: (parentTeachers) => set({ parentTeachers }),
  gradingComponents: [],
  setGradingComponents: (gradingComponents) => set({ gradingComponents }),
  objectiveType: [],
  setObjectiveType: (objectiveType) => set({ objectiveType }),
  catalogs: [],
  setCatalogs: (catalogs) => set({ catalogs }),
  classes: [],
  setClasses: (classes) => set({ classes }),
}));

export default useLookupStore;
